import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import WhatsAppButton from '../../components/feature/WhatsAppButton';
import ScrollToTop from '../../components/feature/ScrollToTop';
import ServiceHero from './components/ServiceHero';
import HormigonImpreso from './components/HormigonImpreso';
import HormigonDesactivado from './components/HormigonDesactivado';
import HormigonPulido from './components/HormigonPulido';
import HormigonRallado from './components/HormigonRallado';
import PiscinasArelite from './components/PiscinasArelite';
import ProteccionesAcabados from './components/ProteccionesAcabados';
import QuoteFormSection from '../home/components/QuoteFormSection';
import { useSEO } from '../../utils/seo';

const ServiciosPage = () => {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://hormipremium.com';

  useSEO({
    title: 'Servicios Hormigón Decorativo Estepona | Impreso, Pulido, Piscinas Arelite',
    description: 'Servicios profesionales de hormigón decorativo en Estepona: hormigón impreso, desactivado, pulido, rallado y piscinas de arena Arelite. Calidad garantizada y presupuesto sin compromiso.',
    keywords: 'servicios hormigón decorativo, hormigón impreso Estepona, hormigón pulido, hormigón rallado, piscinas Arelite, pavimentos decorativos',
    canonical: `${siteUrl}/servicios`,
    schema: {
      '@context': 'https://schema.org',
      '@type': 'Service',
      serviceType: 'Hormigón Decorativo',
      provider: {
        '@type': 'LocalBusiness',
        name: 'HORMI PREMIUM',
        address: {
          '@type': 'PostalAddress',
          addressLocality: 'Estepona',
          addressRegion: 'Andalucía',
          addressCountry: 'ES',
        },
        telephone: '+34640877479',
      },
      areaServed: {
        '@type': 'GeoCircle',
        geoMidpoint: {
          '@type': 'GeoCoordinates',
          latitude: '36.4277',
          longitude: '-5.1483',
        },
        geoRadius: '50000',
      },
      hasOfferCatalog: {
        '@type': 'OfferCatalog',
        name: 'Servicios de Hormigón Decorativo',
        itemListElement: [
          {
            '@type': 'Offer',
            itemOffered: {
              '@type': 'Service',
              name: 'Hormigón Impreso',
              description: 'Pavimentos decorativos con texturas de piedra, madera o adoquín',
            },
          },
          {
            '@type': 'Offer',
            itemOffered: {
              '@type': 'Service',
              name: 'Hormigón Desactivado',
              description: 'Acabado rústico con árido visto, máxima adherencia y resistencia',
            },
          },
          {
            '@type': 'Offer',
            itemOffered: {
              '@type': 'Service',
              name: 'Hormigón Pulido',
              description: 'Superficies continuas y lisas ideales para interiores industriales',
            },
          },
          {
            '@type': 'Offer',
            itemOffered: {
              '@type': 'Service',
              name: 'Hormigón Rallado',
              description: 'Superficie antideslizante con textura rallada para máxima seguridad',
            },
          },
          {
            '@type': 'Offer',
            itemOffered: {
              '@type': 'Service',
              name: 'Piscinas de Arena Arelite',
              description: 'Piscinas con efecto playa natural, diseño exclusivo y elegante',
            },
          },
          {
            '@type': 'Offer',
            itemOffered: {
              '@type': 'Service',
              name: 'Protecciones de Acabados',
              description: 'Selladores profesionales que garantizan durabilidad y belleza permanente',
            },
          },
        ],
      },
    },
  });

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main className="pt-20">
        <ServiceHero />
        <HormigonImpreso />
        <HormigonDesactivado />
        <HormigonPulido />
        <HormigonRallado />
        <PiscinasArelite />
        <ProteccionesAcabados />
        <QuoteFormSection />
      </main>
      <Footer />
      <WhatsAppButton />
      <ScrollToTop />
    </div>
  );
};

export default ServiciosPage;
